// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Iazf","label":"Section_label__2uSEV","contentWrap":"Section_contentWrap__2LtJu","footer":"Section_footer__3qdQe","footerInner":"Section_footerInner__1YDn3"};